export interface User {
  id: number;
  username: string;
  password?: string;
  super_user: boolean;
  can_approve_reviews: boolean;
  deactivated?: boolean;
  system?: string;
}

export type CreateUser = Omit<User, "id">;

export function newUserObj(): CreateUser {
  return {
    username: "",
    super_user: false,
    can_approve_reviews: false,
  };
}
